import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import WebSocketPlugin from './plugins/websocket'
import { initAnalytics } from '@/services/analytics.js';

// Import Tailwind CSS
import './assets/css/tailwind.css'
import 'sweetalert2/dist/sweetalert2.min.css'

// Use plugins
Vue.use(VueSweetalert2)
Vue.use(WebSocketPlugin)

Vue.config.productionTip = false

initAnalytics();

// Add axios for API calls with default configuration
import axios from 'axios'
// Use '/api' so dev proxy or production env var handles full URL
axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/api'

// Add axios interceptor for authentication
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }
  return config
})

// If we already have a token but no user (e.g. after page refresh), fetch the profile
if (store.getters.isAuthenticated && !store.state.user) {
  store.dispatch('fetchUserProfile').catch(() => {
    // token might be invalid – clear it
    store.dispatch('logout')
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
